import { createRouter, createWebHistory } from 'vue-router'
import Home from '../pages/Home.vue'
import Detail from '../pages/Detail.vue'
import GameFrame from '../pages/GameFrame.vue'
import Login from '../pages/Login.vue'
import GameConfig from '../pages/GameConfig.vue'
import { useUserStore } from '../stores/userStore'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/game/:id',
    name: 'Detail',
    component: Detail
  },
  {
    path: '/play/:id',
    name: 'GameFrame',
    component: GameFrame
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/config',
    name: 'GameConfig',
    component: GameConfig,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  
  if (to.meta.requiresAuth && !userStore.isLoggedIn) {
    next('/login')
  } else {
    next()
  }
})

export default router 